import axios from 'axios';

const ApiFactory = ({ container }) => {
  const config = container.get('Configuration');
  const auth = container.get('AuthService');

  return (baseURL = '') => {
    const instance = axios.create({
      baseURL: `${config.gems_url}${baseURL}`,
      headers: {
        Authorization: auth.getAuthHeader(),
      },
    });

    instance.interceptors.response.use(resp => resp, (error) => {
      if (error.response.status === 401) {
        return auth.login();
      }

      return Promise.reject(error);
    });

    return instance;
  };
};

export default ApiFactory;



// WEBPACK FOOTER //
// ./src/services/ApiFactory.js